module.exports = __webpack_public_path__ + "img/expert-icon.0c808e3.svg";